import axios from "axios";
axios.interceptors.request.use((config) => {
  // config.url='https://bajiaoyouxi.cn'+config.url
  config.url=config.url

console.log(config.url,"链接")
  return config;
})
export default axios;
